import styled from "styled-components";

const PageLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  padding-top: 16px;
  // Remove the padding from the actual size of page
  height: calc(100vh - 16px);
  max-height: calc(100vh - 16px);
`;

export default PageLayout;
